import { enUS, de, tr } from 'date-fns/locale';
import type { Locale as DateFnsLocale } from 'date-fns';
import type { Locale } from './index';

/**
 * Map an app locale to its `date-fns` locale object, for use as the
 * `{ locale }` option in `format(...)`. Centralised so date-fns date
 * rendering localises the same way `toBcp47` does for `Intl.*`.
 *
 * Use date-fns *localised* format tokens (`PP`, `PPp`) with this so each
 * language gets its own conventions: EN "Jun 14, 2026", DE "14. Juni 2026",
 * TR "14 Haz 2026".
 */
const DATE_FNS_LOCALES: Record<Locale, DateFnsLocale> = {
  en: enUS,
  de,
  tr,
};

export function dateFnsLocale(locale: Locale): DateFnsLocale {
  return DATE_FNS_LOCALES[locale];
}
